<template>
  <section class="navigation__slider">
    <div class="container navigation__slider-container">
      <nav class="nav">
       <div class="nav__remaining" v-if="remainingSlopes > 0">
         {{ remainingSlopes }} {{ word }} <br> more
       </div>
        <swiper :options="swiperOption" ref="mySwiper">
          <router-link
            :to="`/wizard/${i}/`"
            class="swiper-slide"
            :class="{'disabled' : slopeFromState.materialSize.width === 0}"
            v-for="(item, i) in allSlopes"
            :key="i">
            <div class="slide">
              <div class="slide__img">
                <component
                  :is="allSlopes[i].slopeForm"
                  :navId="i"
                  :navSlopeParams="allSlopes[i].slopeParams"
                  :defaultSvgParams="defaultSvgParams"
                  :isNav="true">
                </component>
              </div>
              <div class="slide__info">
                <div class="slide__info-number"><span v-if="(i + 1) <= 9">0</span>{{ i + 1 }}</div>
                <div class="slide__info-count">x{{ allSlopes[i].slopeCount }}</div>
              </div>
            </div>
          </router-link>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
        <button @click="addFromNav()" class="nav__save"
                :disabled="slopeFromState.materialSize.width === 0">
          <svg width="24" height="24" viewBox="0 0 24 24"
               fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#ECECEC"/>
            <path d="M12 18V6M18 12H6" stroke="#D6D6D6"
            stroke-width="2" stroke-miterlimit="22.9256" stroke-linejoin="round"></path>
          </svg>
         </button>
      </nav>
    </div>
    <section class="nav__pane-section">
      <div class="container">
        <div class="nav__pane">
          <div class="nav__pane-item" @click="removeSlopeType()">
            <div v-if="slopeFromState.slopeType === ''">
              <div class="nav__pane-title"
                   :class="{active: slopeFromState.slopeType === ''}">
                <span class="nav__pane-title--number">1</span>
                <span class="nav__pane-title--text">Slope <br>type</span>
              </div>
            </div>
            <div v-else class="nav__pane-step--passed">
              <img src="@/assets/img/nav-tick.svg" alt="ok">
              <img :src="(slopeType === 'mainSlope')
                        ? require('@/assets/img/mainSlope-nav.svg')
                        : require('@/assets/img/contrSlope-nav.svg')"
                        class="nav__pane-step--passed__img"
                        :alt="(slopeType === 'mainSlope') ? 'Main slope' : 'Counter slope'">
              <div v-html="(slopeType === 'mainSlope') ? 'Main slope' : 'Counter slope'"
                   class="nav__pane-step--passed__title"></div>
            </div>
          </div>
          <div class="nav__pane-item" @click="removeSlopeMaterial()">
            <div v-if="slopeFromState.slopeType === '' || slopeFromState.materialSize.width === 0">
              <div class="nav__pane-title"
                   :class="{active: slopeFromState.slopeType !==
                   '' && slopeFromState.materialSize.width === 0}">
                <span class="nav__pane-title--number">2</span>
                <span class="nav__pane-title--text">Material <br>selection</span>
              </div>
            </div>
            <div v-else class="nav__pane-step--passed">
              <img src="@/assets/img/nav-tick.svg" alt="ok">
              <img :src="allMaterials[index].src"
                   :alt="allMaterials[index].name"
                   class="nav__pane-step--passed__material">
              <div class="nav__pane-step--passed__info">
                <div class="nav__pane-step--passed__title">{{ allMaterials[index].name }}</div>
                <div class="nav__pane-step--passed__title">
                  <img src="@/assets/img/angle.svg" alt="angle">
                    <b>{{ allMaterials[index].angle }}</b>
                </div>
                <div class="nav__pane-step--passed__title">
                  {{ slopeFromState.materialSize.width }}x{{ slopeFromState.materialSize.height }}
                  mm</div>
              </div>
            </div>
          </div>
          <div class="nav__pane-item">
            <div class="nav__pane-title"
                 :class="{active: slopeFromState.slopeType !== ''
                 && slopeFromState.materialSize.width !== 0}">
              <span class="nav__pane-title--number">3</span>
              <div class="nav__pane-step--passed__info">
               <span class="nav__pane-title--text"><i>Area</i> parameters</span>
                <div class="slopeName__input-overlay"
                     v-if="slopeFromState.slopeType !== ''
                           && slopeFromState.materialSize.width !== 0">
                  <input type="text"
                         v-model="slopeFromState.name"
                         class="slopeName__input"
                         @change="updateSlopeName">
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn-result" @click="resultFromNav"
                :disabled="slopeFromState.materialSize.width === 0">
          <img src="@/assets/img/calculator.svg" alt="calculate">
        </button>
      </div>
    </section>
  </section>
</template>

<script>
import { dataLayerPushEvent } from '@/utils/GTM';
import Trapezoid from './figures/Trapezoid.vue';
import Square from './figures/Square.vue';
import ReverseTrapezoid from './figures/ReverseTrapezoid.vue';
import CornerLeftTop from './figures/CornerLeftTop.vue';
import CornerRightTop from './figures/CornerRightTop.vue';
import CornerLeftBottom from './figures/CornerLeftBottom.vue';
import CornerRightBottom from './figures/CornerRightBottom.vue';
import Triangle from './figures/Triangle.vue';
import DoubleSideTriangleHorizontal from './figures/DoubleSideTriangleHorizontal.vue';
import DoubleSideTriangleVertical from './figures/DoubleSideTriangleVertical.vue';
import Rhombus from './figures/Rhombus.vue';
import RectangularTrapezoidHorizontal from './figures/RectangularTrapezoidHorizontal.vue';
import RectangularTrapezoidVertical from './figures/RectangularTrapezoidVertical.vue';
import DoubleSideRectangularTrapezoidVertical from
  './figures/DoubleSideRectangularTrapezoidVertical.vue';

export default {
  props: {
    slopeType: String,
  },
  data() {
    return {
      count: 0,
      swiperOption: {
        slidesPerView: 8,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
        },
        breakpoints: {
          992: {
            slidesPerView: 7,
          },
          680: {
            slidesPerView: 5,
          },
          520: {
            slidesPerView: 4,
          },
          359: {
            slidesPerView: 3,
          },
        },
      },
    };
  },
  components: {
    Trapezoid,
    Square,
    ReverseTrapezoid,
    CornerLeftTop,
    CornerRightTop,
    CornerLeftBottom,
    CornerRightBottom,
    Triangle,
    DoubleSideTriangleHorizontal,
    DoubleSideTriangleVertical,
    Rhombus,
    RectangularTrapezoidHorizontal,
    RectangularTrapezoidVertical,
    DoubleSideRectangularTrapezoidVertical,
  },
  methods: {
    addFromNav() {
      this.$emit('addFromNav');
    },
    resultFromNav() {
      dataLayerPushEvent('calc-wedge-insulating-step2');
      this.$router.push('/result/');
    },
    updateSlopeName() {
      this.$store.commit('updateSlopeName', { id: this.slopeId, name: this.slopeFromState.name });
    },
    removeSlopeMaterial() {
      this.$store.commit('removeSlopeMaterial', this.slopeId);
    },
    removeSlopeType() {
      this.$store.commit('setSlopeToDefault', this.slopeId);
    },
  },
  watch: {
  },
  mounted() {
    // this.swiper.slideTo(this.allSlopes.length);
    // console.log(this.allSlopes);
    // console.log(this.swiper.slides.length);`
  },
  computed: {
    index() {
      return this.allMaterials.findIndex(p => p.id === this.slopeFromState.material);
    },
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    defaultSvgParams() {
      return this.$store.getters.getDafaultSvgParams;
    },
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    remainingSlopes() {
      return this.allSlopes.length - 8;
    },
    word() {
      const cases = [2, 0, 1, 1, 1, 2];
      const words = ['area', 'areas', 'areas'];
      return words[(this.remainingSlopes % 100 > 4
                      && this.remainingSlopes % 100 < 20) ? 2
        : cases[(this.remainingSlopes % 10 < 5)
          ? this.remainingSlopes % 10 : 5]];
    },
  },
};
</script>

<style lang="sass">
.navigation__slider
  .navigation__slider-container
    padding: 0
.nav
  +media((display: (320: grid, 1170: block)))
  // flex-direction: row
  // align-items: center
  // justify-content: space-between
  grid-template-columns: 12fr 2fr
  &__save
    background: none
    box-shadow: none
    cursor: pointer
    border: none
    border: rem(1) solid #D6D6D6
    border-style: dashed
    box-sizing: border-box
    border-radius: rem(4)
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    position: absolute
    top: 50%
    transition: .5s
    overflow: hidden
    outline: none
    +media((position: (320: relative, 992: absolute)))
    +media((right: (320: initial, 1170: rem(-95))))
    +media((top: (320: initial, 1170: 50%)))
    // +media((width: (320: rem(40), 992: rem(85))))
    +media((height: (320: rem(86), 992: rem(82))))
    +media((position: (320: relative, 1170: absolute)))
    +media((transform: (320: translateY(0), 1170: translateY(-50%))))
    +media((width: (320: 100%, 1170: rem(85))))
    +media((max-width: (320: rem(40), 400: rem(50), 576: rem(75), 600: rem(80), 700: rem(85))))
    +media((margin: (320: auto, 768: auto auto auto rem(11), 1170: 0)))
    &:after
      content: "New area"
      position: absolute
      height: 100%
      width: 100%
      top: 0
      left: 0
      color: #fff
      background: $green
      font-family: 'Montserrat', sans-serif
      font-style: normal
      font-weight: 700
      font-size: rem(12)
      line-height: rem(15)
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      transition: .5s
      opacity: 0
      +media((display: (320: none, 992: flex)))
    &:hover
      &:after
        opacity: 1
    svg
      circle, path
        transition: .5s
      circle
        fill: $green
      path
        stroke: #fff
    &:disabled
      svg
        circle
          fill: #ECECEC
        path
          stroke: #D6D6D6
      cursor: no-drop
      &:hover
        &:after
          opacity: 0
  &__remaining
    font-style: normal
    font-weight: 500
    font-size: rem(12)
    line-height: rem(15)
    color: $red
    position: absolute
    width: rem(105)
    top: 50%
    transform: translateY(-50%)
    left: rem(-105)
    +media((display: (320: none, 1170: block)))
nav
  position: relative
  .swiper
    &-container
      // margin-left: rem(-15)
      // margin-right: rem(-15)
      width: auto
      +media((margin: (320: 0, 1170: 0 auto)))
      // +media((width: (320: 86%, 992: 90%, 1170: auto)))
      .swiper-slide
        &.disabled
          pointer-events: none
      &:hover
        .swiper
            &-scrollbar
              &-drag
                background: rgba(227, 7, 19, 0.5)
        > .swiper-scrollbar
          background: rgba(0, 0, 0, 0.1)
    &-slide
      text-decoration: none
      svg
        +media((max-width: (320: 100%, 1170: initial)))
        +media((max-height: (320: rem(57), 768: initial)))
      &:before
        height: 100%
        width: 100%
        content: url(../assets/img/cog.svg)
        position: absolute
        top: 0
        left: 0
        pointer-events: none
        background: rgba(51, 51, 51, 0.4)
        border: rem(1) solid #D6D6D6
        opacity: 0
        transition: .5s
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        box-sizing: border-box
        z-index: 1
      &:hover
        &:before
          opacity: 1
      &.router-link-active
        .slide__info-number
          color: $black
        &:before
          background: #fff
          opacity: 1
          border: none
          border-top: rem(4) solid $red
          border-bottom: rem(4) solid transparent
          box-shadow: 0 rem(1) rem(5) rgba(51, 51, 51, 0.5)
          content: url(../assets/img/cog-active.svg)
    &-scrollbar
      height: rem(4)
      top: 0
      &-drag
        border-radius: rem(12)
        background: rgba(227, 7, 19, 0.2)
  .swiper-container-horizontal > .swiper-scrollbar
    background: rgba(0, 0, 0, 0.05)
    height: rem(4)
    width: 100%
    left: 0
  .slide
    display: flex
    flex-direction: column
    // justify-content: space-between
    align-items: center
    padding: rem(10)
    padding-top: 0
    background: rgba(246, 246, 246, 0.15)
    box-shadow: inset rem(-1) 0 0 #D6D6D6
    &__img
      padding-top: rem(13)
    &__info
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      width: 100%
      &-number, &-count
        font-style: normal
        font-size: rem(12)
        line-height: 1
        color: #999999
        transition: .5s
      &-count
        font-weight: 500
      &-number
        font-weight: bold
        z-index: 2
.nav
  &__pane
    grid-template-columns: 2fr 3fr 3fr
    +media((display: (320: flex, 1170: grid)))
    +media((margin: (320: 0, 1170: 0 rem(-15))))
    +media((width: (320: 100%, 1170: calc(100% + 30px))))
    &-item
      min-height: rem(102)
      display: flex
      flex-direction: row
      align-items: center
      cursor: pointer
      box-shadow: inset rem(-1) 0 0 #ECECEC
      +media((padding-left: (320: rem(14), 992: 0)))
      +media((padding-right: (320: 0, 992: rem(20), 1170: 0)))
      &:first-of-type
        +media((padding-left: (992: rem(20), 1170: 0)))
      &:nth-child(2), &:nth-child(3)
        +media((padding-left: (320: rem(14), 992: rem(20), 1170: rem(40))))
      &:last-of-type
        box-shadow: none
    &-title
      font-style: normal
      font-weight: 500
      font-size: rem(12)
      line-height: rem(18)
      color: #999999
      display: flex
      flex-direction: row
      align-items: center
      br
        +media((display: (320: block, 576: none)))
      &--number
        font-style: normal
        font-weight: 600
        font-size: rem(14)
        line-height: rem(30)
        color: #FFFFFF
        height: rem(24)
        width: rem(24)
        background: #C9C9C9
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        border-radius: 50%
        +media((margin-right: (320: rem(14), 992: rem(16))))
      &.active
        color: $black
        font-weight: bold
        // +media((min-width: (320: calc(100vw - 168px), 360: calc(100vw - 194px),
        // 768: calc(100vw - 223px), 992: auto)))
        +media((width: (320: 100% , 992: auto)))
        +media((padding-right: (320: rem(14), 768: none)))
        .nav__pane-title--number
          background: $red
        .nav__pane-title--text
          display: block
      &--text
        text-align: left
        +media((display: (320: none, 992: block)))
        i
          font-style: normal
          +media((display: (320: none, 992: inline-block)))
    &-step
      &--passed
        display: flex
        flex-direction: row
        align-items: center
        +media((padding-right: (320: rem(14), 992: 0)))
        &__title
          font-style: normal
          font-weight: 500
          font-size: rem(12)
          line-height: rem(18)
          color: $black
          text-align: left
          +media((display: (320: none, 992: block)))
        &__img
          margin: 0 rem(17)
          +media((display: (320: none, 992: block)))
        &__material
          max-width: rem(80)
          margin: 0 rem(17)
          +media((display: (320: none, 992: block)))
        &__info
          display: flex
          flex-direction: column
          align-items: flex-start
    .slopeName
      &__input
        background: none
        box-shadow: none
        border: none
        box-sizing: border-box
        font-family: $main-font
        font-style: normal
        font-weight: 500
        font-size: rem(12)
        line-height: rem(18)
        color: $black
        outline: none
        +media((padding: (320: rem(6) 0 rem(8), 992: rem(6) rem(27) rem(6) rem(10))))
        +media((width: (320: rem(102), 360: rem(116), 400: rem(150), 576: rem(240),
        992: rem(200), 1170: rem(240))))
        +media((border: (320: none, 992: rem(1) solid #C9C9C9)))
        +media((box-shadow: (320: inset 0 rem(-2) 0 #ECECEC, 992: none)))
        &-overlay
          position: relative
          &:after
            content: ""
            height: rem(24)
            width: rem(24)
            background: url(../assets/img/pen.svg)
            position: absolute
            right: rem(3)
            top: 50%
            transform: translateY(-50%)
    &-section
      background: #fff
      box-shadow: 0 rem(1) rem(5) rgba(51, 51, 51, 0.5)
      // +media((width: (320: calc(100% - 50px), 360: calc(100% - 76px),
      // 768: calc(100vw - 105px), 1070: auto)))
      .container
        position: relative
        grid-template-columns: 11fr 3fr
        +media((display: (320: grid, 1170: flex)))
        +media((padding: (320: 0, 1170: 0 rem(15))))
        +media((grid-template-columns: (320: 12fr 2fr, 360: 11fr 3fr, 500: 12fr 2fr)))
      .btn
        &-result
          top: 0
          height: rem(102)
          background: none
          outline: none
          box-shadow: none
          border: none
          transition: .5s
          background: $red
          cursor: pointer
          display: flex
          flex-direction: column
          justify-content: center
          align-items: center
          max-width: rem(105)
          +media((position: (320: relative, 1170: absolute)))
          +media((width: (320: 100%, 992: rem(105))))
          +media((right: (320: initial, 1170: rem(-105))))
          &:hover
            background: $red-hover
          &:disabled
            cursor: no-drop
            background: #ECECEC
            &:hover
              background: $red
              background: #ECECEC
</style>
